/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/dashboard'
    }
];

export const createDefaultNavigation = (userData: any): FuseNavigationItem[] => [
    {
        id   : 'home',
        title: 'Home',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/dashboard'
    },
    {
        id   : 'statistics',
        title: 'Statistics',
        type : 'basic',
        icon : 'mat_outline:area_chart',
        link : '/statistics'
    },
    {
        id   : 'links',
        title: 'Links',
        type : 'basic',
        icon : 'mat_outline:link',
        link : '/links',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_SHORTENED_LINKS');
        }              
    },
    {
        id   : 'broken_links',
        title: 'Broken links',
        type : 'basic',
        icon : 'mat_outline:link_off',
        link : '/brokenlinks',
        hidden: () => {
            return !userData || !userData.permissions.includes('SEARCH_SHORTENED_LINKS');
        }     
    },        
    {
        id   : 'campaigns',
        title: 'Campaigns',
        type : 'basic',
        icon : 'heroicons_outline:building-storefront',
        link : '/ads',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_ADS');
        }        
    },
    {
        id   : 'Compliance',
        title: 'Compliance',
        type : 'group',
        icon : 'mat_outline:local_police',
        children: [
            {
                id   : 'requirements',
                title: 'Requirements',
                type : 'basic',
                icon : 'mat_outline:admin_panel_settings',
                link : '/compliance',
                hidden: () => {
                    return !userData || !userData.permissions.includes('READ_COMPLIANCE');
                }                
            },
            {
                id   : 'searchlinks',
                title: 'Search links',
                type : 'basic',
                icon : 'mat_outline:pageview',
                link : '/searchlinks',
                hidden: () => {
                    return !userData || !userData.permissions.includes('SEARCH_SHORTENED_LINKS');
                }                     
            }
        ],
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_COMPLIANCE');
        }             
    },    
    {
        id   : 'account',
        title: 'Account',
        type : 'group',
        icon : 'heroicons_outline:window',
        children: [
            {
                id   : 'payments',
                title: 'Payments',
                type : 'basic',
                icon : 'heroicons_outline:currency-euro',
                link : '/payments'
            },
            // {
            //     id   : 'alerts',
            //     title: 'Alerts',
            //     type : 'basic',
            //     icon : 'heroicons_outline:bell-alert',
            //     link : '/alerts',
            // },
            {
                id   : 'users',
                title: 'Users',
                type : 'basic',
                icon : 'heroicons_outline:users',
                link : '/users',
                hidden: () => {
                    return !userData || !userData.permissions.includes('LIST_USERS');
                }                
            }
        ],
        hidden: () => {
            return !userData || !userData.permissions.includes('LIST_USERS');
        }             
    },
    {
        id   : 'help',
        title: 'Help',
        type : 'group',
        icon : 'heroicons_outline:question-mark-circle',
        children: [
            {
                id   : 'help.faqs',
                title: 'FAQs',
                type : 'basic',
                icon : 'heroicons_outline:information-circle',
                link : '/faq',
            },
            {
                id   : 'help.support',
                title: 'Support',
                type : 'basic',
                icon : 'heroicons_outline:chat-bubble-bottom-center-text',
                link : '/support',
            }
        ],
    }
];
export const createCompactNavigation = createDefaultNavigation;
export const createFuturisticNavigation = createDefaultNavigation;
export const createHorizontalNavigation = createDefaultNavigation;

